import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Header from '@/components/Header'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Header',
      component: Home
    },
    {
      path: '/Header',
      name: 'Header',
      component: Header
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js